/* Arflonia Kategorie-Seite v2 (2026-10-15)
   · Filtern / Sortieren / Seiten ohne Neuladen (Section Rendering API), Adresse bleibt teilbar
   · „Weitere Produkte laden“ hängt die nächste Seite an
   · Bottom-Sheet „Filtern & Sortieren“ auf Handy/Tablet
   · Preis-Schieberegler, Marken-Suche, „+ weitere Marken“
   · „In den Warenkorb“ → grün „Hinzugefügt“ + Mini-Warenkorb (arf-cards.js hört auf arf:cart:added)
   · Merken (Herz) – gleiche Liste wie bisher: localStorage „arflonia:wishlist:v1“ */
(function () {
  'use strict';
  if (window.__arfColV2) return;
  window.__arfColV2 = true;

  var D = document;
  var busy = null;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var WKEY = 'arflonia:wishlist:v1';

  function rootOf(el) { return el && el.closest ? el.closest('[data-arfc]') : null; }
  function sectionUrl(url, sid) {
    var u = new URL(url, D.baseURI || location.href);
    u.searchParams.set('section_id', sid);
    return u.toString();
  }
  function cleanUrl(url) {
    var u = new URL(url, D.baseURI || location.href);
    u.searchParams.delete('section_id');
    return u.pathname + (u.search ? u.search : '');
  }
  function lock(on) { D.documentElement.classList.toggle('arfc-lock', !!on); }
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  function setOpen(root, open, focusSort) {
    if (!root) return;
    root.classList.toggle('is-open', !!open);
    var ov = root.querySelector('.arfc-overlay');
    if (ov) ov.hidden = !open;
    var btn = root.querySelector('[data-arfc-open]');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    lock(open);
    if (open) {
      var form = root.querySelector('.arfc-form');
      if (form) form.scrollTop = 0;
      var x = root.querySelector('.arfc-side .arfc-x');
      if (x) setTimeout(function () { x.focus({ preventScroll: true }); }, 60);
    }
  }

  /* ---------- Wunschliste ---------- */
  function readW() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]') || []; } catch (e) { return []; } }
  function writeW(a) { try { localStorage.setItem(WKEY, JSON.stringify(a)); } catch (e) {} }
  function syncWish(scope) {
    var saved = readW();
    Array.prototype.forEach.call((scope || D).querySelectorAll('[data-arfc-wish]'), function (b) {
      var on = saved.indexOf(b.getAttribute('data-handle')) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  /* ---------- Preis-Schieberegler ---------- */
  function initPrice(scope) {
    Array.prototype.forEach.call((scope || D).querySelectorAll('[data-arfc-price-box]'), function (box) {
      if (box.__arfc) return; box.__arfc = 1;
      var max = parseFloat(box.getAttribute('data-max')) || 100;
      var rMin = box.querySelector('[data-arfc-range="min"]'), rMax = box.querySelector('[data-arfc-range="max"]');
      var iMin = box.querySelector('[data-arfc-price="min"]'), iMax = box.querySelector('[data-arfc-price="max"]');
      var wrap = box.querySelector('.arfc-range');
      function paint() {
        var a = parseFloat(rMin.value) || 0, b = parseFloat(rMax.value) || max;
        wrap.style.setProperty('--a', (a / max * 100) + '%');
        wrap.style.setProperty('--b', (b / max * 100) + '%');
      }
      function fromRange(e) {
        var a = parseFloat(rMin.value), b = parseFloat(rMax.value);
        if (a > b - 1) { if (e && e.target === rMin) { rMin.value = a = Math.max(0, b - 1); } else { rMax.value = b = Math.min(max, a + 1); } }
        iMin.value = a > 0 ? a : '';
        iMax.value = b < max ? b : '';
        paint();
      }
      rMin.addEventListener('input', fromRange);
      rMax.addEventListener('input', fromRange);
      [iMin, iMax].forEach(function (inp) {
        inp.addEventListener('input', function () {
          var a = parseFloat(iMin.value), b = parseFloat(iMax.value);
          rMin.value = isNaN(a) ? 0 : Math.max(0, Math.min(max, a));
          rMax.value = isNaN(b) ? max : Math.max(0, Math.min(max, b));
          paint();
        });
      });
      var commit = function () { var f = box.closest('[data-arfc-form]'); var root = rootOf(box); if (f && root) render(root, formUrl(f)); };
      rMin.addEventListener('change', commit);
      rMax.addEventListener('change', commit);
      paint();
    });
  }

  function afterRender(scope) {
    initPrice(scope);
    syncWish(scope);
    showActiveTile(scope);
    initTiles(scope);
    if (window.arfFit) window.arfFit(scope);
  }

  function render(root, url, push) {
    var sid = root.getAttribute('data-section');
    var wasOpen = root.classList.contains('is-open');
    var wasDeals = root.classList.contains('is-deals');
    if (busy && busy.abort) busy.abort();
    busy = 'AbortController' in window ? new AbortController() : null;
    root.classList.add('is-loading');
    return fetch(sectionUrl(url, sid), { credentials: 'same-origin', signal: busy ? busy.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-arfc]');
        if (!fresh) throw new Error('no section');
        var formOld = root.querySelector('.arfc-form');
        var keepScroll = formOld ? formOld.scrollTop : 0;
        var expanded = Array.prototype.map.call(root.querySelectorAll('.arfc-fg.is-expanded'), function (g) { var t = g.querySelector('.arfc-fg__t'); return t ? t.textContent.trim() : ''; });
        root.innerHTML = fresh.innerHTML;
        root.classList.remove('is-loading');
        Array.prototype.forEach.call(root.querySelectorAll('.arfc-fg'), function (g) { var t = g.querySelector('.arfc-fg__t'); if (t && expanded.indexOf(t.textContent.trim()) > -1) expandGroup(g, true); });
        if (wasOpen) {
          root.classList.add('is-open');
          var ov = root.querySelector('.arfc-overlay'); if (ov) ov.hidden = false;
          var f = root.querySelector('.arfc-form'); if (f) f.scrollTop = keepScroll;
        }
        if (push !== false) history.pushState({ arfc: 1 }, '', cleanUrl(url));
        if (!wasOpen) {
          var bar = root.querySelector('.arfc-bar');
          if (bar) {
            var top = bar.getBoundingClientRect().top;
            if (top < 0 || top > window.innerHeight * 0.6) bar.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
          }
        }
        root.__orig = null;
        afterRender(root);
        if (wasDeals || new URLSearchParams(location.search).get('angebote') === '1') setDeals(root, true, false);
        dealsBadge(root);
        D.dispatchEvent(new CustomEvent('arf:collection:updated', { detail: { url: url } }));
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        location.href = cleanUrl(url);
      });
  }

  function formUrl(form) {
    var fd = new FormData(form);
    var p = new URLSearchParams();
    fd.forEach(function (v, k) { if (k === 'arfc_sort') return; if (String(v).trim() !== '') p.append(k, v); });
    var root = rootOf(form);
    var sel = root && root.querySelector('[data-arfc-sort]');
    if (sel && !p.has('sort_by') && sel.value && sel.value !== sel.getAttribute('data-default')) p.set('sort_by', sel.value);
    var qs = p.toString();
    return form.getAttribute('action') + (qs ? '?' + qs : '');
  }

  function expandGroup(g, on) {
    g.classList.toggle('is-expanded', on);
    var b = g.querySelector('[data-arfc-more-opts]');
    if (!b) return;
    if (!b.getAttribute('data-more')) b.setAttribute('data-more', b.textContent);
    b.textContent = on ? (b.getAttribute('data-less') || 'Weniger anzeigen') : b.getAttribute('data-more');
  }

  var t;
  D.addEventListener('change', function (e) {
    var el = e.target;
    var root = rootOf(el); if (!root) return;
    if (el.matches('[data-arfc-sort]')) {
      var form = root.querySelector('[data-arfc-form]');
      if (form) render(root, formUrl(form));
      return;
    }
    if (el.matches('[data-arfc-sortradio]')) {
      var sel = root.querySelector('[data-arfc-sort]');
      if (sel) sel.value = el.value;
      var f0 = root.querySelector('[data-arfc-form]');
      if (f0) render(root, formUrl(f0));
      return;
    }
    if (el.matches('[data-arfc-range]')) return; /* eigener Commit */
    if (el.closest('[data-arfc-form]') && !el.matches('[data-arfc-fsearch]')) {
      clearTimeout(t);
      var f = el.closest('[data-arfc-form]');
      t = setTimeout(function () { render(root, formUrl(f)); }, el.matches('[data-arfc-price]') ? 50 : 200);
    }
  });

  D.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = D.querySelector('[data-arfc].is-open'); if (open) setOpen(open, false);
      return;
    }
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-arfc-price]')) {
      e.preventDefault();
      var root = rootOf(e.target); var f = e.target.closest('[data-arfc-form]');
      if (root && f) render(root, formUrl(f));
    }
  });

  D.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-arfc-form]'); if (!f) return;
    e.preventDefault();
    render(rootOf(f), formUrl(f));
  });

  /* Marken-Suche */
  D.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-arfc-fsearch]')) return;
    var q = e.target.value.trim().toLowerCase();
    var g = e.target.closest('.arfc-fg'); if (!g) return;
    var list = g.querySelector('[data-arfc-opts]'); if (!list) return;
    if (q !== '') g.classList.add('is-expanded');
    Array.prototype.forEach.call(list.children, function (li) {
      li.classList.toggle('is-hidden', q !== '' && (li.getAttribute('data-label') || '').indexOf(q) === -1);
    });
  });

  /* ---------- In den Warenkorb: sofort grün (1 s), Mini-Warenkorb sofort (3 s, arf-cards.js) ---------- */
  function counts(n) {
    Array.prototype.forEach.call(D.querySelectorAll('.pets-desktop-cart-count,.pets-mobile-cart-count,[data-cart-count]'), function (el) {
      el.textContent = n; el.classList.toggle('is-empty', n < 1);
    });
  }
  function cardInfo(card, btn) {
    if (!card) return { title: '', img: '', qty: 1, line: null };
    var t = card.querySelector('.arfc-card__title'), im = card.querySelector('.arfc-card__img img');
    var p = btn ? parseInt(btn.getAttribute('data-price'), 10) : NaN;
    return { title: t ? t.textContent.replace(/\s+/g, ' ').trim() : '', img: im ? (im.currentSrc || im.src) : '', qty: 1, line: isNaN(p) ? null : p };
  }
  function addToCart(btn) {
    if (btn.classList.contains('is-busy')) return;
    var id = parseInt(btn.getAttribute('data-arfc-add'), 10); if (!id) return;
    var lbl = btn.querySelector('.arfc-cta__l');
    var old = lbl ? (lbl.getAttribute('data-l') || lbl.textContent) : '';
    if (lbl) lbl.setAttribute('data-l', old);
    var card = btn.closest('[data-arfc-card]');
    var html0 = btn.__arfcH || (btn.__arfcH = btn.innerHTML);
    function restore() { clearTimeout(leave); btn.classList.remove('is-added', 'is-busy', 'arf-is-added', 'arf-is-leaving'); btn.innerHTML = html0; btn.classList.add('arf-is-back'); setTimeout(function () { btn.classList.remove('arf-is-back'); }, 450); }
    btn.classList.add('is-busy', 'is-added');
    if (lbl) lbl.textContent = 'Hinzugefügt';
    var leave = setTimeout(function () { btn.classList.add('arf-is-leaving'); }, 1000), back = setTimeout(restore, 1200);
    var cs = Array.prototype.slice.call(D.querySelectorAll('.pets-desktop-cart-count,.pets-mobile-cart-count,[data-cart-count]'));
    var before = cs.map(function (el) { return parseInt(el.textContent, 10) || 0; });
    cs.forEach(function (el, i) { el.textContent = before[i] + 1; el.classList.remove('is-empty'); });
    var mini = (window.ArfMini && !/^\/cart\/?$/.test(location.pathname)) ? window.ArfMini : null;
    if (mini) { try { mini.show(cardInfo(card, btn)); } catch (e) { mini = null; } }
    fetch(ROOT + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function (res) {
        var items = res.items || [res];
        D.dispatchEvent(new CustomEvent('arf:cart:added', { bubbles: true, detail: mini ? { items: items, arfMini: 1 } : { items: items } }));
        D.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return fetch(ROOT + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); });
      })
      .then(function (c) { if (c) { counts(c.item_count); if (mini && mini.update) mini.update(c); } })
      .catch(function () {
        clearTimeout(back); restore();
        cs.forEach(function (el, i) { el.textContent = before[i]; el.classList.toggle('is-empty', before[i] < 1); });
        if (mini && mini.close) mini.close();
        var a = card && card.querySelector('a[href]'); if (a) location.href = a.href;
      });
  }

  /* ---------- Kategorie-Kreise: Pfeile ---------- */
  function initTiles(scope) {
    Array.prototype.forEach.call((scope || D).querySelectorAll('[data-arfc-tiles]'), function (nav) {
      if (nav.__arfc) { if (nav.__upd) nav.__upd(); return; }
      nav.__arfc = 1;
      var list = nav.querySelector('[data-arfc-tlist]'); if (!list) return;
      var prev = nav.querySelector('[data-arfc-tnav="-1"]'), next = nav.querySelector('[data-arfc-tnav="1"]');
      var raf = 0;
      function upd() { raf = 0; var max = list.scrollWidth - list.clientWidth; if (prev) prev.hidden = list.scrollLeft <= 4; if (next) next.hidden = max <= 4 || list.scrollLeft >= max - 4; }
      nav.__upd = upd;
      list.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(upd); }, { passive: true });
      window.addEventListener('resize', function () { if (!raf) raf = requestAnimationFrame(upd); });
      upd(); setTimeout(upd, 500); window.addEventListener('load', upd);
    });
  }

  /* ---------- Angebote direkt auf der Seite (Vorlage collection.arfc-deals) ---------- */
  var dealsCache = {};
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function baseQuery() { var u = new URL(location.href); ['page', 'angebote', 'section_id', 'view'].forEach(function (k) { u.searchParams.delete(k); }); return u; }
  function loadDeals() {
    var u = baseQuery(); var key = u.pathname + '?' + u.searchParams.toString();
    if (dealsCache[key]) return dealsCache[key];
    function pageUrl(n) { var x = new URL(u.toString()); x.searchParams.set('view', 'arfc-deals'); x.searchParams.set('page', n); return x.pathname + '?' + x.searchParams.toString(); }
    function get(n) { return fetch(pageUrl(n), { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (t) { return JSON.parse(t); }); }
    var p = get(1).then(function (first) {
      var pages = Math.min(first.pages || 1, 12), rest = [];
      for (var i = 2; i <= pages; i++) rest.push(get(i));
      return Promise.all(rest).then(function (others) {
        var all = [first].concat(others);
        return { sale: all.reduce(function (s, j) { return s + (j.sale || 0); }, 0), html: all.map(function (j) { return j.html || ''; }).join(''), total: first.total };
      });
    });
    p.catch(function () { delete dealsCache[key]; });
    dealsCache[key] = p;
    return p;
  }
  function paintDeals(root, on, n) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-arfc-deals]'), function (b) {
      if (b.classList.contains('arfc-toggle')) b.setAttribute('aria-checked', on ? 'true' : 'false');
      else { b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); }
    });
    if (typeof n === 'number') Array.prototype.forEach.call(root.querySelectorAll('[data-arfc-deals-n]'), function (s) { s.textContent = n > 0 ? ' · ' + n : ''; });
  }
  function dealsParam(on) {
    try { var u = new URL(location.href); if (on) u.searchParams.set('angebote', '1'); else u.searchParams.delete('angebote'); history.replaceState(history.state, '', u.pathname + (u.search ? u.search : '')); } catch (e) {}
  }
  function setDeals(root, on, scroll) {
    var grid = root.querySelector('[data-arfc-grid]'), info = root.querySelector('[data-arfc-resinfo] p'), none = root.querySelector('[data-arfc-nodeals]');
    var title = root.getAttribute('data-title') || '';
    if (on) {
      if (!root.__orig) root.__orig = { grid: grid ? grid.innerHTML : null, info: info ? info.innerHTML : '' };
      root.classList.add('is-deals', 'is-deals-loading');
      paintDeals(root, true);
      dealsParam(true);
      return loadDeals().then(function (d) {
        if (!root.classList.contains('is-deals')) return;
        root.classList.remove('is-deals-loading');
        paintDeals(root, true, d.sale);
        if (d.sale > 0) {
          if (grid) { grid.hidden = false; grid.innerHTML = d.html; syncWish(grid); if (window.arfFit) window.arfFit(grid); }
          if (none) none.hidden = true;
          if (info) info.innerHTML = '<b>' + d.sale + (d.sale === 1 ? ' Angebot' : ' Angebote') + '</b> in ' + esc(title);
        } else {
          if (grid) grid.hidden = true;
          if (none) none.hidden = false;
          if (info) info.innerHTML = '<b>0 Angebote</b> in ' + esc(title);
        }
        if (scroll !== false) {
          var bar = root.querySelector('.arfc-bar');
          if (bar && bar.getBoundingClientRect().top < 0) bar.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
        }
      }).catch(function () { root.classList.remove('is-deals-loading'); setDeals(root, false); });
    }
    root.classList.remove('is-deals', 'is-deals-loading');
    paintDeals(root, false);
    if (root.__orig) {
      if (grid && root.__orig.grid !== null) { grid.innerHTML = root.__orig.grid; syncWish(grid); }
      if (info) info.innerHTML = root.__orig.info;
      root.__orig = null;
    }
    if (grid) grid.hidden = false;
    if (none) none.hidden = true;
    dealsParam(false);
  }
  function dealsBadge(root) {
    if (!root || !root.querySelector('[data-arfc-deals-n]')) return;
    var run = function () { loadDeals().then(function (d) { if (root.isConnected) paintDeals(root, root.classList.contains('is-deals'), d.sale); }).catch(function () {}); };
    if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 3000 }); else setTimeout(run, 1200);
  }

  D.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('[data-arfc-add]');
    if (add) { e.preventDefault(); addToCart(add); return; }

    var tn = e.target.closest && e.target.closest('[data-arfc-tnav]');
    if (tn) { var tl = tn.parentElement && tn.parentElement.querySelector('[data-arfc-tlist]'); if (tl) var tli = tl.querySelector('li'); var tstep = tli ? tli.getBoundingClientRect().width + (parseFloat(getComputedStyle(tl).columnGap) || 0) : 166; /* Pfeile: genau eine Kategorie pro Klick */
      tl.scrollBy({ left: (parseInt(tn.getAttribute('data-arfc-tnav'), 10) || 1) * tstep, behavior: reduced() ? 'auto' : 'smooth' }); return; }

    var dl = e.target.closest && e.target.closest('[data-arfc-deals], [data-arfc-deals-off]');
    if (dl) { e.preventDefault(); var dr = rootOf(dl); if (dr) setDeals(dr, dl.hasAttribute('data-arfc-deals-off') ? false : !dr.classList.contains('is-deals')); return; }

    var wish = e.target.closest && e.target.closest('[data-arfc-wish]');
    if (wish) {
      e.preventDefault();
      var h = wish.getAttribute('data-handle'), saved = readW(), i = saved.indexOf(h);
      if (i > -1) saved.splice(i, 1); else saved.push(h);
      writeW(saved);
      wish.setAttribute('aria-pressed', i > -1 ? 'false' : 'true');
      return;
    }

    var more = e.target.closest && e.target.closest('[data-arfc-more-opts]');
    if (more) { var g = more.closest('.arfc-fg'); expandGroup(g, !g.classList.contains('is-expanded')); return; }

    var a = e.target.closest && e.target.closest('[data-arfc-link], [data-arfc-more-btn], [data-arfc-open], [data-arfc-close]');
    if (!a) return;
    var root = rootOf(a); if (!root) return;

    if (a.hasAttribute('data-arfc-open')) {
      setOpen(root, true);
      if (a.getAttribute('data-arfc-open') === 'sort') {
        var s = root.querySelector('.arfc-fg--sort'); var f = root.querySelector('.arfc-form');
        if (s && f) setTimeout(function () { f.scrollTop = 0; }, 30);
      }
      return;
    }
    if (a.hasAttribute('data-arfc-close')) { e.preventDefault(); setOpen(root, false); return; }
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;

    if (a.hasAttribute('data-arfc-more-btn')) {
      e.preventDefault();
      if (a.classList.contains('is-busy')) return;
      a.classList.add('is-busy'); a.setAttribute('aria-busy', 'true');
      var label = a.textContent; a.textContent = 'Lädt …';
      fetch(sectionUrl(a.href, root.getAttribute('data-section')), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = root.querySelector('[data-arfc-grid]');
          var items = doc.querySelectorAll('[data-arfc-grid] > [data-arfc-item]');
          var first = null;
          Array.prototype.forEach.call(items, function (li) {
            var n = D.importNode(li, true); n.classList.add('is-new'); grid.appendChild(n); if (!first) first = n;
          });
          var m = root.querySelector('[data-arfc-more]');
          var fm = doc.querySelector('[data-arfc-more]');
          if (m && fm) m.innerHTML = fm.innerHTML;
          history.replaceState({ arfc: 1 }, '', cleanUrl(a.href));
          syncWish(grid);
          if (window.arfFit) window.arfFit(grid);
          if (first) { var l = first.querySelector('a[href]'); if (l) l.focus({ preventScroll: true }); }
        })
        .catch(function () { location.href = a.href; })
        .then(function () { a.classList.remove('is-busy'); a.removeAttribute('aria-busy'); if (a.isConnected) a.textContent = label; });
      return;
    }

    e.preventDefault();
    render(root, a.getAttribute('href'));
  });

  function showActiveTile(scope) {
    Array.prototype.forEach.call((scope || D).querySelectorAll('.arfc-tiles__list'), function (list) {
      var a = list.querySelector('.arfc-tile.is-active'); if (!a) return;
      var li = a.parentElement; var lr = list.getBoundingClientRect(), ar = li.getBoundingClientRect();
      if (ar.right <= lr.right && ar.left >= lr.left) return;
      var x = list.scrollLeft + (ar.left - lr.left) - (list.clientWidth - ar.width) / 2;
      if (x > 0) list.scrollLeft = x;
    });
  }
  /* Filterleiste (Desktop): eigene schmale Scrollleiste. Scrollt man die Seite, scrollt die Filterleiste im gleichen Tempo mit – bis „Verfügbarkeit“ ganz sichtbar ist, dann bleibt sie stehen. Beim Hochscrollen läuft sie genauso zurück. */
  var sideY = window.scrollY || 0, sideLastTop = null;
  function sideTick() {
    var side = D.querySelector('.arfc-side');
    var y = window.scrollY || 0, dy = y - sideY; sideY = y;
    if (!side || !window.matchMedia('(min-width: 990px)').matches) return;
    var head = parseFloat(getComputedStyle(D.documentElement).getPropertyValue('--arfc-top')) || 0;
    var stuck = head + 16, r = side.getBoundingClientRect();
    var last = sideLastTop; sideLastTop = r.top;
    if (!dy || r.top > stuck + 1) return;
    var amt = dy;
    if (dy > 0 && last !== null && last > stuck + 1) amt = Math.max(0, dy - (last - stuck));
    var max = side.scrollHeight - side.clientHeight;
    var av = side.querySelector('input[name="filter.v.availability"]');
    var stop = av && av.closest('.arfc-fg');
    if (stop) max = Math.min(max, stop.getBoundingClientRect().bottom - r.top + side.scrollTop - side.clientHeight + 14);
    max = Math.max(0, max);
    var cur = side.scrollTop;
    if (amt > 0) { if (cur < max) side.scrollTop = Math.min(max, cur + amt); }
    else if (amt < 0) side.scrollTop = Math.max(0, cur + amt);
  }
  D.addEventListener('toggle', function () { requestAnimationFrame(sideTick); }, true);
  D.addEventListener('arf:collection:updated', function () { requestAnimationFrame(sideTick); });
  window.addEventListener('resize', function () { requestAnimationFrame(sideTick); });
  window.addEventListener('load', function () { setTimeout(sideTick, 50); });

  function setTop() {
    var h = 0, el = D.elementFromPoint(Math.round(window.innerWidth / 2), 3);
    while (el && el !== D.body && el !== D.documentElement) {
      var p = getComputedStyle(el).position;
      if (p === 'fixed' || p === 'sticky') { var r = el.getBoundingClientRect(); if (r.top <= 6 && r.height > 0 && r.height < 260) h = Math.max(h, r.bottom); }
      el = el.parentElement;
    }
    D.documentElement.style.setProperty('--arfc-top', Math.round(h) + 'px');
  }
  function boot() {
    setTop(); afterRender(D); sideTick();
    var r0 = D.querySelector('[data-arfc]');
    if (r0) { if (new URLSearchParams(location.search).get('angebote') === '1') setDeals(r0, true, false); dealsBadge(r0); }
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', setTop);
  var topRaf = 0;
  window.addEventListener('scroll', function () { if (!topRaf) topRaf = requestAnimationFrame(function () { topRaf = 0; setTop(); sideTick(); }); }, { passive: true });
  window.addEventListener('resize', function () { clearTimeout(window.__arfcRT); window.__arfcRT = setTimeout(setTop, 150); });

  /* „Ratgeber lesen ↓“: weich zum Ratgeber scrollen – ohne #-Sprung, der die Seite neu geladen und zurückgesprungen hat */
  D.addEventListener('click', function (e) {
    var m = e.target.closest && e.target.closest('.arfc-intro__more'); if (!m) return;
    var id = (m.getAttribute('href') || '').split('#')[1]; var tg = id && D.getElementById(id); if (!tg) return;
    e.preventDefault();
    var off = Math.max(parseFloat(getComputedStyle(D.documentElement).getPropertyValue('--arfc-top')) || 0, 64) + 16;
    window.scrollTo({ top: tg.getBoundingClientRect().top + (window.scrollY || 0) - off, behavior: reduced() ? 'auto' : 'smooth' });
  });

  /* Adresse, die die Liste gerade zeigt – ein reiner #-Wechsel lädt nichts neu */
  var shownUrl = location.pathname + location.search;
  ['pushState', 'replaceState'].forEach(function (m) {
    var o = history[m]; if (typeof o !== 'function') return;
    history[m] = function () { var res = o.apply(this, arguments); shownUrl = location.pathname + location.search; return res; };
  });
  window.addEventListener('popstate', function () {
    var now = location.pathname + location.search;
    if (now === shownUrl) return;
    shownUrl = now;
    var root = D.querySelector('[data-arfc]');
    if (root) render(root, location.pathname + location.search, false);
  });
})();
